module.exports = __webpack_public_path__ + "static/media/twitter.efc4c13d.jpg";